import Shimmer from "@/components/Shimmer";

const EmailDashboardLoading = () => {
  return (
    <>
      <div className="mb-30 grid grid-cols-1 gap-20 sm:grid-cols-4">
        <Shimmer height={130} />
        <Shimmer height={130} />
        <Shimmer height={130} />
        <Shimmer height={130} />
      </div>
      <div className="mb-30">
        <Shimmer height={35} />
      </div>
      <div className="mb-30 grid grid-cols-1 gap-20 sm:grid-cols-2">
        <Shimmer height={130} />
        <Shimmer height={130} />
      </div>
      <div className="mb-30">
        <Shimmer height={35} />
      </div>
      <div className="mb-20">
        <Shimmer height={427} />
      </div>
      <div className="mb-30 grid grid-cols-1 gap-20 sm:grid-cols-2">
        <Shimmer height={466} />
        <Shimmer height={466} />
        <Shimmer height={466} />
        <Shimmer height={466} />
      </div>
    </>
  );
};

export default EmailDashboardLoading;
